export default "__VITE_ASSET__BVqUWhQd__"